import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/constants/testIds";

const items = [
  {
    q: "Is Zaplee.ai HIPAA compliant?",
    a: "Yes. Zaplee.ai is built on a HIPAA-aligned infrastructure with encryption in transit and at rest, granular access controls, full audit logs, and BAAs with our subprocessors.",
  },
  {
    q: "Which EHRs and clearinghouses do you support?",
    a: "We connect to most major EHR/PM systems (TheraNest, SimplePractice, Athenahealth, eClinicalWorks, Tebra and more) and clearinghouses via API and SFTP. If yours isn't listed, our integration team will scope it during onboarding.",
  },
  {
    q: "How long does onboarding take?",
    a: "Most single-practice teams are live in 2–3 weeks. Multi-practice billing companies typically onboard one practice at a time and reach full coverage in 4–8 weeks depending on data volume.",
  },
  {
    q: "Who is Zaplee.ai built for?",
    a: "Mental and behavioral health practices, multi-specialty medical groups, and billing companies that manage RCM for multiple clinics. The platform is multi-tenant by design.",
  },
  {
    q: "Does Zaplee.ai replace my billers?",
    a: "No. It removes the repetitive work — eligibility checks, clean-claim scrubbing, status follow-up, posting — so your billers focus on judgment calls, appeals and patient communication.",
  },
  {
    q: "How is pricing structured?",
    a: "We offer per-practice and per-claim plans depending on volume. Book a demo and we'll quote based on your stack and your collections.",
  },
];

export const FAQSection = () => {
  return (
    <section
      id="faq"
      data-testid={FAQ.section}
      className="relative py-24 md:py-32"
    >
      <div className="mx-auto max-w-3xl px-6 lg:px-10">
        <div className="text-center">
          <span className="font-mono-label text-[10px] text-[#0047FF]">
            // Frequently asked
          </span>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl font-semibold tracking-tighter text-zinc-950">
            Answers, before you ask.
          </h2>
          <p className="mt-5 text-lg text-zinc-600">
            Have something specific? Reach out below and we&apos;ll get back the same day.
          </p>
        </div>

        <Accordion type="single" collapsible className="mt-12">
          {items.map((it, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={FAQ.item(i)}
              className="border-b border-zinc-200"
            >
              <AccordionTrigger className="text-left font-display text-lg font-semibold tracking-tight text-zinc-950 hover:no-underline">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-600 text-base leading-relaxed">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
